(() => {
  if (window.PDLSmartSearch) return;
  const config = JSON.parse(document.getElementById('pdl-smart-search-config')?.textContent || '{}');
  const text = config.text || {};
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

  const tireNumber = value => String(value || '').toLowerCase().replace(/,/g,'.').replace(/c$/,'').trim();
  const tireWidth = value => {
    const clean=tireNumber(value).replace(/\s*[×x]\s*/g,' x ').replace(/\s+/g,' ');
    return /^\d+(?:\.\d+)?$/.test(clean)?String(Number(clean)):clean;
  };
  const rimPattern='(?:700|650|29|28|27[.,]5|27|26|24|22|20|18|16|14|12|10|8[.,]5)';
  function tireMeasure(value) {
    const input=String(value || '').toLowerCase();
    const found=new RegExp('\\b('+rimPattern+')(?:c)?(?![\\d.,])(?:\\s*["”]?[\\s]*[x×]\\s*(\\d+(?:[.,]\\d+)?(?:\\s+\\d+\\/\\d+)?(?:\\/\\d+)?(?:\\s*[x×]\\s*\\d+)?[c]?))?','i').exec(input);
    return found?{rim:tireNumber(found[1]),width:tireWidth(found[2]),raw:found[0],index:found.index}:null;
  }
  function tireQuery(query) {
    if(!/\bpneus?\b/i.test(query) || /\b(camaras?|selantes?|remendos?|fitas?|espatulas?|protetores?|reparadores?|calibradores?|infladores?)\b/.test(normalize(query)))return null;
    const measure=tireMeasure(query);
    const remaining=measure?query.slice(0,measure.index)+' '+query.slice(measure.index+measure.raw.length):query;
    return {rim:measure?.rim || '',width:measure?.width || '',remaining:remaining.replace(/\baro\b/gi,' ').trim()};
  }
  function tireMeasures(product) {
    const tags=(product.tags || []).filter(tag=>/^pdl-medida-/i.test(tag)).map(tag=>{
      const parts=tag.slice(11).toLowerCase().split('x');
      const rim=parts.shift().replace(/-/g,'.');
      const width=parts.join('x').replace(/^(\d+)-(\d+)-(\d+)/,'$1 $2/$3').replace(/-/g,'.');
      return {rim:tireNumber(rim),width:tireWidth(width)};
    });
    if(tags.length)return tags;
    const measure=tireMeasure(product.title);
    return measure?[measure]:[];
  }
  const isTire = product => !/carrinho de mao/.test(normalize(product.title)) && (/^pneus?\b/.test(normalize(product.title)) || /^pneus?$/.test(normalize(product.type)) || (product.tags || []).some(tag=>/^pdl-medida-/i.test(tag)));


  function rimQuery(query) {
    const normalized=normalize(query);
    if(!/\baros?\b/.test(normalized) || /\b(pneus?|bicicletas?|bikes?|camaras?|rodas?|raios?|cubos?|protetores?|fitas?|tampas?|aneis|anel|freios?)\b/.test(normalized))return null;
    const holes=/\b(\d{2})\s*(?:furos?|f)\b/i.exec(query);
    const withoutHoles=holes?query.slice(0,holes.index)+' '+query.slice(holes.index+holes[0].length):query;
    const measure=tireMeasure(withoutHoles);
    const remaining=measure?withoutHoles.slice(0,measure.index)+' '+withoutHoles.slice(measure.index+measure.raw.length):withoutHoles;
    return {rim:measure?.rim || '',holes:holes?.[1] || '',remaining:remaining.trim()};
  }
  function rimMeasures(product) {
    const tagged=(product.tags || []).map(tag=>tag.match(/^pdl-aro-(.+)-(\d+)f$/i)).filter(Boolean).map(found=>({rim:found[1].replace(/-/g,'.'),holes:found[2]}));
    if(tagged.length)return tagged;
    const size=tireMeasure(product.title),holes=String(product.title || '').match(/\b(\d{2})\s*(?:furos?|f)\b/i);
    return size?[{rim:size.rim,holes:holes?.[1] || ''}]:[];
  }
  const isRim=product=>(product.tags || []).some(tag=>/^pdl-aro-.+-\d+f$/i.test(tag)) || /^(?:par\s+(?:de\s+)?)?aros?\b/.test(normalize(product.title));


  const tubeNumber = value => String(value || '').replace(/,/g,'.').replace(/\s+/g,' ').trim();
  function tubeMeasure(value) {
    const input=String(value || '').replace(/,/g,'.');
    const found=/\b(700|200|29|28|27\.5|27|26|24|20|16|14|12(?:\s+1\/2)?)(?:c)?(?![\d.])(?:\s*[x×]\s*(\d+\s+\d+\/\d+|\d+(?:\.\d+)?(?:\s*[/–-]\s*\d+(?:\.\d+)?)?)[c]?)?/i.exec(input);
    if(!found)return null;
    let width=tubeNumber(found[2]);
    if(width && !/\s+\d+\/\d+/.test(width))width=width.split(/\s*[/–-]\s*/).map(n=>String(Number(n))).join('–');
    return {rim:tubeNumber(found[1]),width,raw:found[0],index:found.index};
  }
  const isTube = product => /^camaras?\b/.test(normalize(product.title));
  function tubeMeasures(product) {
    return (product.tubeMeasures || []).map(tubeMeasure).filter(Boolean);
  }
  function tubeQuery(query) {
    if(!/\bc(?:a|â)mer?as?\b/i.test(query) && !/\bcamaras?\b/.test(normalize(query)))return null;
    if(/\b(remendos?|protetores?|porcas?|valvulas?|fitas?|pneus?|cameras? de acao)\b/.test(normalize(query)))return null;
    const measure=tubeMeasure(query);
    const rest=measure?query.slice(0,measure.index)+' '+query.slice(measure.index+measure.raw.length):query;
    return {rim:measure?.rim || '',width:measure?.width || '',remaining:rest.replace(/\bc(?:a|â)mer?as?\b/gi,'camara').replace(/\baro\b/gi,'').trim()};
  }
  function tubeWidthMatches(stored,requested) {
    if(!requested)return true;
    if(stored===requested)return true;
    if(!/^\d+(?:\.\d+)?$/.test(requested))return false;
    const range=stored.match(/^(\d+(?:\.\d+)?)–(\d+(?:\.\d+)?)$/);
    return !!range && Number(requested)>=Number(range[1]) && Number(requested)<=Number(range[2]);
  }

  const compact = value => normalize(value).replace(/\s/g, '');
  const words = value => normalize(value).split(/\s+/).filter(Boolean);
  const escape = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const stop = new Set(['de','do','da','dos','das','para','com','e','a','o','um','uma']);
  const families = [
    {terms:['mesa','mesas','avanco','avancos','mesa de guidao','avanco de guidao'],handles:['mesas-e-avancos']},
    {terms:['manopla','manoplas','punho','punhos','punho de guidao'],handles:['manoplas-punhos-e-fitas']},
    {terms:['movimento central','caixa de centro','caixas de centro'],handles:['caixas-de-centro']},
    {terms:['canote','canotes','canote de selim','espigao de selim','canote do banco'],handles:['canotes']},
    {terms:['selim','selins','banco','banco de bicicleta'],handles:['selins']},
    {terms:['alavanca de cambio','passador','passadores','passador de marcha','trocador','trocadores','trocador de marcha'],handles:['alavancas']},
    {terms:['manete de freio','manetes de freio','alavanca de freio','alavancas de freios'],handles:['alavancas-de-freios']},
    {terms:['roldana','roldanas','polia','polias','polia de cambio','polia guia','polia tensora'],handles:['roldanas']},
    {terms:['disco de freio','discos de freio','rotor','rotores','rotor de freio'],handles:['discos-de-freio']},
    {terms:['suporte de caramanhola','suporte de garrafa','suporte caramanhola'],handles:['suportes-caramanhola']},
    {terms:['caramanhola','caramanholas','garrafa','garrafas','garrafa de hidratacao','squeeze'],handles:['caramanholas']},
    {terms:['blocagem','blocagens','blocagem de roda','quick release','aperto rapido'],handles:['blocagens']},
    {terms:['camara de ar','camaras de ar','camara','camaras','camera','cameras'],handles:['camaras']},
    {terms:['abracadeira de selim','bracadeira de selim','abracadeira de canote','bracadeira de canote'],handles:['abracadeiras']},
    {terms:['caixa de direcao','caixas de direcao','headset'],handles:['caixas-de-direcao']},
    {terms:['conduite','conduites','conduite de cambio','espiral de cambio','capa externa do cabo'],handles:['cabos-e-conduites']},
    {terms:['cambio traseiro','desviador traseiro'],handles:['cambios-traseiro','cambios-traseiros']},
    {terms:['cambio dianteiro','desviador dianteiro'],handles:['cambios-dianteiro','cambios-dianteiros']},
    {terms:['catraca','catracas','catraca de roda livre','roda livre multipla'],handles:['catracas']},
    {terms:['corpo de roda livre','freehub body'],handles:['freehubs']},
    {terms:['roda livre'],handles:['catracas','freehubs']},
    {terms:['bicicleta','bicicletas','bike','bikes','bici'],handles:[],categoryPrefix:'bicicletas'},
    {terms:['bicicleta de estrada','road bike','speed'],handles:['bicicletas-speed']},
    {terms:['capacete','capacetes'],handles:['capacetes']},
    {terms:['sapatilha','sapatilhas'],handles:['sapatilhas']},
    {terms:['sapata','sapatas','sapata de freio','sapatas para freio'],handles:['sapatas-para-freio']},
    {terms:['pneu','pneus'],handles:['pneus']},
    {terms:['aro','aros'],handles:['aros']},
    {terms:['freio','freios'],handles:['freios']},
    {terms:['cambio','cambios'],handles:[],categoryPrefix:'cambios'},
    {terms:['cassete','cassetes'],handles:['cassetes']},
    {terms:['pedivela','pedivelas'],handles:['pedivelas']}
  ];
  const aliases = new Map([['absl','absolute'],['abs','absolute']]);
  const phrases = families.flatMap(family => family.terms.filter(term => words(term).length > 1).map(term => ({family,term,tokens:words(term).filter(token => !stop.has(token))}))).sort((a,b) => b.tokens.length-a.tokens.length);
  const pending = new Map();
  const completed = new Map();
  const transportCache = new Map();
  try {
    for(let index=sessionStorage.length-1;index>=0;index--) {
      const key=sessionStorage.key(index);
      if(!key?.startsWith('pdl-search-data:') && !key?.startsWith('pdl-smart-search:'))continue;
      const saved=JSON.parse(sessionStorage.getItem(key)||'null');
      if(!key.includes(`:${config.version}:`) || !saved || Date.now()-saved.time>=(saved.ttl || 60000))sessionStorage.removeItem(key);
    }
  } catch {}
  function cached(key, factory) {
    const ttl=key.startsWith('cards:') || key.startsWith('facets:')?60000:key.includes('/collections?')?900000:120000;
    const cacheKey = `pdl-search-data:${config.version}:${key}`;
    const held = transportCache.get(cacheKey);
    if (held && Date.now()-held.time < ttl) return held.promise;
    try {
      const saved=JSON.parse(sessionStorage.getItem(cacheKey)||'null');
      if(saved && Date.now()-saved.time < ttl) {
        const promise=Promise.resolve(saved.value);
        transportCache.set(cacheKey,{time:saved.time,promise});return promise;
      }
    } catch {}
    const time=Date.now();
    const promise=factory().then(value => {
      try {sessionStorage.setItem(cacheKey,JSON.stringify({time,ttl,value}));}catch{}
      return value;
    }).catch(error => {transportCache.delete(cacheKey);throw error;});
    if(transportCache.size>=24)transportCache.delete(transportCache.keys().next().value);
    transportCache.set(cacheKey,{time,promise});return promise;
  }
  let collectionsPromise;
  let vehiclesPromise;
  const localizedPath = path => `${(config.root || '/').replace(/\/$/, '')}${path}`;
  const urlFor = (path, params = {}) => {
    const url = new URL(path, location.origin);
    for (const [name,value] of Object.entries(params)) if (value !== undefined && value !== '') url.searchParams.set(name,value);
    return url;
  };
  async function json(url) {
    const response = await fetch(url, {headers:{Accept:'text/html'}});
    if (!response.ok) throw new Error(text.error || 'Não foi possível carregar a busca.');
    const data = JSON.parse(await response.text());
    if (!Array.isArray(data.products) && !Array.isArray(data.collections)) throw new Error(text.error);
    return data;
  }
  function pages(path,params,key) {
    return cached(String(urlFor(path,params)),() => collectPages(path,params,key));
  }
  async function collectPages(path,params,key) {
    const first = await json(urlFor(path,params));
    const output = [...first[key]];
    for (let page=2;page<=Number(first.pages || 1);page+=3) {
      const batch = await Promise.all(Array.from({length:Math.min(3,Number(first.pages)-page+1)},(_,index) => json(urlFor(path,{...params,page:page+index}))));
      batch.forEach(data => output.push(...data[key]));
    }
    return output;
  }
  function collections() {
    if (!collectionsPromise) collectionsPromise = pages(localizedPath('/collections'),{view:'pdl-search-data'},'collections').catch(error => { collectionsPromise=null; throw error; });
    return collectionsPromise;
  }
  function unitsFor(query) {
    const tokens = words(query).filter(token => !stop.has(token));
    const units = [];
    for (let index=0;index<tokens.length;) {
      const phrase = phrases.find(item => item.tokens.every((token,offset) => token === tokens[index+offset] || (tokens[index+offset]?.length >= 3 && token.startsWith(tokens[index+offset]))));
      if (phrase) {
        units.push({tokens:tokens.slice(index,index+phrase.tokens.length),families:[phrase.family]});
        index += phrase.tokens.length;
        continue;
      }
      const token=tokens[index++];
      if (stop.has(token)) continue;
      const matches = token.length>=3 ? families.filter(family => (family.handles[0]!=='aros' || rimQuery(query)) && family.terms.some(term => words(term).length===1 && (term===token || term.startsWith(token)))) : [];
      units.push({tokens:[token],families:matches});
    }
    const hasComponent = units.some(unit => unit.families.some(family => !family.categoryPrefix && !family.handles.includes('bicicletas-speed')));
    return hasComponent ? units.filter(unit => !unit.families.some(family => family.categoryPrefix==='bicicletas')) : units;
  }
  const singular = token => /^[a-z]{4,}$/.test(token) && /(?:as|os|es)$/.test(token) ? token.slice(0,-1) : token;
  const exactWord = (needle,word) => needle===word || singular(needle)===singular(word);
  const prefix = (needle,value) => words(value).some(word => exactWord(needle,word) || (needle.length>=3 && word.startsWith(needle)));
  const exactPhraseMatches = (tokens,value) => tokens.filter(token => !stop.has(token)).every(token => words(value).some(word => exactWord(token,word)));
  const unitTerms = unit => [unit.tokens,unit.tokens.map(token => aliases.get(token)||token),...unit.families.flatMap(family => family.terms.map(term => words(term).filter(token => !stop.has(token))))];
  const phraseMatches = (tokens,value) => tokens.filter(token => !stop.has(token)).every(token => prefix(token,value));
  const atomicCollection = collection => !/^(tudo|outras|outros|pecas|acessorios)\b/.test(normalize(collection.title)) && !/catracas e cassetes/.test(normalize(collection.title));
  const familyCollection = (family,collection) => family.handles.includes(collection.handle) || (family.categoryPrefix && normalize(collection.title).startsWith(family.categoryPrefix) && atomicCollection(collection));
  function unitScore(unit,product) {
    const variants = product.variants.filter(variant => variant.available);
    if (unit.families.some(family => family.categoryPrefix === 'bicicletas')) {
      if (/^(bicicletas?|bikes?)\b/.test(normalize(product.title))) return 50;
      if (/^(bicicletas?|bikes?)$/.test(normalize(product.type))) return 30;
      return product.collections.some(collection => familyCollection(unit.families.find(family => family.categoryPrefix === 'bicicletas'), collection) && normalize(collection.title) !== 'bicicletas') ? 20 : 0;
    }
    const terms = unitTerms(unit);
    let score=exactPhraseMatches(unit.tokens,product.title) ? (exactWord(unit.tokens[0],words(product.title)[0] || '')?100:90) : 0;
    for (const term of terms) {
      if (phraseMatches(term,product.title)) score=Math.max(score,prefix(term[0],words(product.title)[0])?70:50);
      if (phraseMatches(term,product.vendor)) score=Math.max(score,35);
      if (phraseMatches(term,product.type)) score=Math.max(score,30);
      if (variants.some(variant => phraseMatches(term,variant.title))) score=Math.max(score,25);
      if (variants.some(variant => phraseMatches(term,variant.sku))) score=Math.max(score,45);
      if (!unit.families.length && product.collections.some(collection => atomicCollection(collection) && phraseMatches(term,collection.title))) score=Math.max(score,15);
    }
    if (unit.families.some(family => family.handles[0]!=='manoplas-punhos-e-fitas' && product.collections.some(collection => familyCollection(family,collection)))) score=Math.max(score,20);
    return score;
  }
  function match(product,query,units=unitsFor(query)) {
    if (!product.available) return null;
    const available = product.variants.filter(variant => variant.available);
    const queryCode=compact(query);
    const exact=available.filter(variant => compact(variant.sku) && compact(variant.sku)===queryCode);
    if (exact.length) return {...product,score:1000,exactVariantIds:exact.map(variant => String(variant.id))};
    if (/^(?=.*\d)[a-z\d._/-]+$/i.test(query.trim())) {
      const partial=available.filter(variant => compact(variant.sku).startsWith(queryCode));
      if (queryCode.length>=2 && partial.length) return {...product,score:800,exactVariantIds:partial.map(variant => String(variant.id))};
    }
    const tube=tubeQuery(query);
    if(tube) {
      if(!isTube(product))return null;
      if((tube.rim || tube.width) && !tubeMeasures(product).some(measure=>(!tube.rim || measure.rim===tube.rim) && tubeWidthMatches(measure.width,tube.width)))return null;
      units=unitsFor(tube.remaining);
    }
    const tire=tireQuery(query);
    if(tire) {
      if(!isTire(product))return null;
      if(tire.rim && !tireMeasures(product).some(measure=>measure.rim===tire.rim && (!tire.width || measure.width===tire.width)))return null;
      units=unitsFor(tire.remaining);
    }
    const wheelRim=rimQuery(query);
    if(wheelRim) {
      if(!isRim(product))return null;
      if((wheelRim.rim || wheelRim.holes) && !rimMeasures(product).some(measure=>(!wheelRim.rim || measure.rim===wheelRim.rim) && (!wheelRim.holes || measure.holes===wheelRim.holes)))return null;
      units=unitsFor(wheelRim.remaining);
    }
    if (!units.length) return null;
    let score=0;
    for (const unit of units) {
      const value=unitScore(unit,product);
      if (!value) return null;
      score+=value;
    }
    return {...product,score,exactVariantIds:[]};
  }
  function collectionScore(collection,units) {
    if (!collection.count) return 0;
    let score=0;
    for (const unit of units) {
      if (unit.families.some(family => familyCollection(family,collection))) score+=100;
      else if (phraseMatches(unit.tokens,collection.title)) score+=40;
    }
    if (!atomicCollection(collection)) score-=25;
    score-=words(collection.title).length;
    return score>0?score:0;
  }
  function nativeQuery(query,units) {
    if (/^(?=.*\d)[a-z\d._/-]+$/i.test(query.trim())) return query.trim();
    return units.map(unit => {
      const alternatives=[...new Map(unitTerms(unit).map(tokens => tokens.map(singular)).filter(tokens => tokens.length).map(tokens => [tokens.join(' '),tokens])).values()];
      const covers=(broader,narrower) => broader.every(token => narrower.some(value => value===token || (token.length>=3 && value.startsWith(token))));
      const distinct=alternatives.filter((tokens,index) => !alternatives.some((other,otherIndex) => otherIndex!==index && covers(other,tokens) && (!covers(tokens,other) || otherIndex<index)));
      const queries=distinct.map(tokens => tokens.map(token => `${token}${token.length>=3?'*':''}`).join(' AND '));
      return queries.length>1 ? `(${queries.map(query => query.includes(' AND ')?`(${query})`:query).join(' OR ')})` : queries[0];
    }).join(' AND ');
  }
  const sourceProducts = products => [...new Map(products.flatMap(product => product.sources || [product]).map(product => [String(product.id),product])).values()];
  const skuSetKey = product => [...new Set(product.variants.map(variant=>normalize(variant.sku)).filter(Boolean))].sort().join('|');
  function productLocations(product, variants=product.variants.filter(variant => variant.available)) {
    const locations=variants.flatMap(variant => (variant.locations || []).filter(location => location.available).map(location => normalize(location.name)));
    const tags=(product.tags || []).map(normalize);
    const names=locations.length?locations:tags;
    const result=new Set();
    if(names.some(name => name.includes('porto alegre')))result.add('poa');
    if((locations.length || !result.size) && names.some(name => name.includes('sao leopoldo') || name.includes('matriz')))result.add('matriz');
    return result;
  }
  function canonicalScore(product,variants=product.variants.filter(variant => variant.available)) {
    const locations=productLocations(product,variants);
    return (locations.has('matriz')?100000:locations.has('poa')?10000:0)+(variants.some(variant=>variant.available)?1000:0)+Math.min(Number(product.stock)||0,999);
  }
  function logicalProducts(products) {
    products=sourceProducts(products);
    const owner = new Map();
    const parent=products.map((_,index) => index);
    const find=index => { while(parent[index]!==index){parent[index]=parent[parent[index]];index=parent[index];} return index; };
    products.forEach((product,index) => {
      const matches=product.exactVariantIds || [];
      const set=skuSetKey(product);
      if(set) {
        const key=`set:${set}|${product.price}`;
        if(owner.has(key))parent[find(index)]=find(owner.get(key));
        else owner.set(key,index);
      }
      product.variants.filter(variant => variant.available && variant.sku && (!matches.length || matches.includes(String(variant.id)))).forEach(variant => {
        const key=`sku:${normalize(variant.sku)}|${variant.price}`;
        if(owner.has(key)) parent[find(index)]=find(owner.get(key));
        else owner.set(key,index);
      });
    });
    const groups=new Map();
    products.forEach((product,index) => {const key=find(index);if(!groups.has(key))groups.set(key,[]);groups.get(key).push(product);});
    return [...groups.values()].map(group => {
      const variants=product=>product.variants.filter(variant=>variant.available && (!product.exactVariantIds?.length || product.exactVariantIds.includes(String(variant.id))));
      group.sort((a,b) => canonicalScore(b,variants(b))-canonicalScore(a,variants(a)) || b.score-a.score || a.id-b.id);
      const stores=new Set(group.flatMap(product=>[...productLocations(product,variants(product))]));
      return {...group[0],score:Math.max(...group.map(product=>product.score)),sources:group,stores:Math.max(1,stores.size)};
    }).sort((a,b) => b.score-a.score || normalize(a.title).localeCompare(normalize(b.title),'pt-BR',{numeric:true}) || a.id-b.id);
  }
  function prepareLogicalCards(cards,products,pageNumber) {
    const allowed=new Map(sourceProducts(products).map(product=>[String(product.id),product]));
    const items=[];
    for(const card of cards) {
      const product=allowed.get(card.dataset.productId);if(!product)continue;
      const link=card.querySelector('a.product-card__link[href],a[ref="productCardLink"][href]');
      const variantId=card.dataset.pdlVariantId || (link?new URL(link.getAttribute('href'),location.origin).searchParams.get('variant'):'');
      if(product.exactVariantIds.length && variantId && !product.exactVariantIds.includes(String(variantId)))continue;
      const variant=product.variants.find(item=>String(item.id)===String(variantId)) || product.variants.find(item=>item.available);
      if(!variant)continue;
      const color=normalize(card.querySelector('.pk-variant-grid-info > p')?.textContent || '');
      const colorIndex=(product.options || []).findIndex(option=>/cor|color/.test(normalize(option)));
      const variants=product.variants.filter(item=>item.available && (!color || normalize(item.options?.[colorIndex])===color));
      items.push({card,product,variant,variants,color,price:Number(variant.price),locations:productLocations(product,variants)});
    }
    const parent=items.map((_,index)=>index);
    const find=index=>{while(parent[index]!==index){parent[index]=parent[parent[index]];index=parent[index];}return index;};
    for(let a=0;a<items.length;a++)for(let b=a+1;b<items.length;b++) {
      const first=items[a],second=items[b];
      if(first.color!==second.color || first.price!==second.price || first.product.id===second.product.id)continue;
      const sharedSku=first.variants.some(variant=>variant.sku && second.variants.some(other=>other.sku && normalize(variant.sku)===normalize(other.sku) && variant.price===other.price));
      const firstSet=skuSetKey(first.product),secondSet=skuSetKey(second.product);
      if(sharedSku || (firstSet && firstSet===secondSet))parent[find(b)]=find(a);
    }
    const groups=new Map();
    items.forEach((item,index)=>{const key=find(index);if(!groups.has(key))groups.set(key,[]);groups.get(key).push(item);});
    const order=new Map(products.map((product,index)=>[String(product.id),index]));
    products.forEach((product,index)=>(product.sources || [product]).forEach(source=>order.set(String(source.id),index)));
    return [...groups.values()].map(group=>{
      group.sort((a,b)=>canonicalScore(b.product,b.variants)-canonicalScore(a.product,a.variants) || a.product.id-b.product.id);
      const item=group[0],card=item.card;
      const stores=new Set(group.flatMap(source=>[...source.locations]));
      if(group.length>1) {
        card.classList.add('pdl-logical-card--merged');
        card.dataset.pdlLogicalCanonical='true';
        card.dataset.pdlLogicalSources=JSON.stringify(group.map(source=>({productId:String(source.product.id),variantId:String(source.variant.id),handle:source.product.handle,sku:source.variant.sku,location:[...source.locations][0] || 'unknown',inventory:source.product.stock,available:true,variants:source.product.variants})));
      }
      if(stores.size>1) {
        const badge=card.querySelector('.location-badge');
        if(badge) {
          const label=badge.querySelector('.location-badge__label');if(label)label.textContent=text.twoStoresLabel;
          badge.setAttribute('aria-label',text.twoStores);badge.setAttribute('title',text.twoStores);
          badge.classList.add('location-badge--logical-merged');
        } else {
          const image=card.querySelector('.pk-variant-grid-image,.card-gallery,[ref="cardGallery"],.product-card__media');
          if(image)image.insertAdjacentHTML('beforeend',`<span class="pdl-smart-stores" role="status" style="position:absolute;left:10px;bottom:10px;z-index:4">${escape(text.twoStoresLabel)}</span>`);
        }
      }
      card.dataset.pdlSmartOrder=String(order.get(String(item.product.id)));
      card.style.order=card.dataset.pdlSmartOrder;
      card.dataset.page=String(pageNumber);card.dataset.pdlLogicalPrepared='true';
      card.querySelectorAll('script').forEach(script=>script.remove());
      return card;
    });
  }
  async function resolve(query) {
    const requestedTube=tubeQuery(query);
    if(requestedTube) {
      const units=unitsFor(requestedTube.remaining);
      const candidates=await pages(localizedPath('/collections/camaras'),{view:'pdl-search-data'},'products');
      const products=logicalProducts(candidates.map(product=>match(product,query,units)).filter(Boolean));
      return {products,collections:products.length?[{title:'Câmaras',handle:'camaras',url:localizedPath('/collections/camaras'),count:products.length}]:[],units};
    }
    const units=unitsFor(query);
    if (!units.length) return {products:[],collections:[],units};
    const allCollectionsPromise=collections();
    const request={q:nativeQuery(query,units),type:'product','options[unavailable_products]':'hide','options[prefix]':'last',view:'pdl-search-data'};
    const nativeRequests=[pages(config.searchUrl || localizedPath('/search'),request,'products')];
    const nativeResultsPromise=Promise.all(nativeRequests);
    // Keep native requests in flight while the collection index is loading.
    // Observe early rejection; the final await below still reports the error.
    nativeResultsPromise.catch(() => {});
    const allCollections=await allCollectionsPromise;
    const suggested=allCollections.map(collection => ({...collection,score:collectionScore(collection,units)})).filter(collection => collection.score>0).sort((a,b) => b.score-a.score || a.title.localeCompare(b.title,'pt-BR'));
    const sourceCollections=suggested.filter(collection => atomicCollection(collection) && units.some(unit => unit.families.length ? unit.families.some(family => familyCollection(family,collection)) : phraseMatches(unit.tokens,collection.title)));
    const collectionProducts = async () => {
      const found=new Map();
      const source=sourceCollections.toSorted((a,b) => b.count-a.count);
      const add=data => data.forEach(product => found.set(String(product.id),product));
      const covered=collection => {
        let count=0;
        for(const product of found.values())if(product.collections.some(item => item.handle===collection.handle))count++;
        return count===Number(collection.count);
      };
      const first=source.length>4?source.slice(0,1):source;
      (await Promise.all(first.map(collection => pages(collection.url,{view:'pdl-search-data'},'products')))).forEach(add);
      const remaining=source.filter(collection => !first.includes(collection) && !covered(collection));
      let next=0;
      await Promise.all(Array.from({length:Math.min(4,remaining.length)},async () => {
        while(next<remaining.length) {
          const collection=remaining[next++];
          if(!covered(collection))add(await pages(collection.url,{view:'pdl-search-data'},'products'));
        }
      }));
      return [...found.values()];
    };
    const [nativeResults,collectionResults]=await Promise.all([nativeResultsPromise,collectionProducts()]);
    const candidates=new Map([...nativeResults.flat(),...collectionResults].map(product => [String(product.id),product]));
    const products=logicalProducts([...candidates.values()].map(product => match(product,query,units)).filter(Boolean));
    const seenTitles=new Set();
    const matchedSources=sourceProducts(products);
    const supported=suggested.filter(collection => matchedSources.some(product => product.collections.some(item => item.handle===collection.handle)));
    const suggestions=supported.filter(collection => {const name=normalize(collection.title);if(seenTitles.has(name))return false;seenTitles.add(name);return true;}).slice(0,4);
    return {products,collections:suggestions,units};
  }
  function search(query) {
    const key=normalize(query);
    if(completed.has(key))return Promise.resolve(completed.get(key));
    const storageKey=`pdl-smart-search:${config.version || '1'}:${key}`;
    try {const saved=JSON.parse(sessionStorage.getItem(storageKey)||'null');if(saved && Date.now()-saved.time<60000){completed.set(key,saved.result);return Promise.resolve(saved.result);}}catch{}
    if(!pending.has(key)) pending.set(key,resolve(query).then(result => {if(completed.size>=12)completed.delete(completed.keys().next().value);completed.set(key,result);try{sessionStorage.setItem(storageKey,JSON.stringify({time:Date.now(),result}));}catch{}return result;}).finally(() => pending.delete(key)));
    return pending.get(key);
  }
  const money=value => new Intl.NumberFormat(config.locale || 'pt-BR',{style:'currency',currency:config.currency || 'BRL'}).format(Number(value)/100);
  function previewProduct(product) {
    const variant=product.variants.find(item => product.exactVariantIds.includes(String(item.id))) || product.variants.find(item => item.available);
    const url=variant && product.exactVariantIds.length?`${product.url}?variant=${variant.id}`:product.url;
    const price=variant && product.exactVariantIds.length?variant.price:product.price;
    const pix=config.pixEnabled && price>=config.minPrice && config.pixPercent>0?`<span class="pdl-smart-pix">${escape(money(Math.floor(price*(100-config.pixPercent)/100)))} ${escape(text.pix)}</span>`:'';
    return `<li class="predictive-search-results__card predictive-search-results__card--product" ref="resultsItems[]" data-pdl-resource-product-id="${product.id}" data-pdl-resource-title="${escape(product.title)}" data-pdl-resource-price="${price}"><a class="pdl-smart-product" href="${escape(url)}">${product.image?`<img src="${escape(product.image)}" alt="" loading="lazy" width="160" height="160">`:''}<span class="resource-card__title">${escape(product.title)}</span>${pix}<span class="pdl-smart-price">${escape(money(price))}</span>${product.stores>1?`<span class="pdl-smart-stores">${escape(text.twoStoresLabel)}</span>`:''}</a></li>`;
  }
  function collectionMarkup(result) {
    if(!result.collections.length)return '';
    return `<div id="predictive-search-collection" class="pdl-predictive-collections"><div class="pdl-predictive-collections__title">${escape(text.collections)}</div><div class="pdl-predictive-collections__links">${result.collections.map(collection => `<a class="pdl-predictive-collection-link" ref="resultsItems[]" href="${escape(collection.url)}">${escape(collection.title)}</a>`).join('')}</div></div>`;
  }
  function markup(query,result) {
    return `<div id="predictive-search-results" class="predictive-search-results" data-search-results><div class="predictive-search-results__inner" data-search-results>${collectionMarkup(result)}<div id="predictive-search-products" class="predictive-search-results__products"><h4 class="predictive-search-results__title">${escape(text.products)}</h4><ul class="predictive-search-results__list predictive-search-results__wrapper-products list-unstyled">${result.products.slice(0,8).map(previewProduct).join('')}</ul></div>${!result.products.length?`<p class="predictive-search-results__no-results">${escape(text.noResults)}</p>`:''}<div class="visually-hidden" role="status">${result.products.length} ${escape(text.products)}: ${escape(query)}</div></div></div>`;
  }
  function searchUrl(query) {
    return urlFor(config.searchUrl || localizedPath('/search'),{q:query.trim(),type:'product','options[unavailable_products]':'hide','options[prefix]':'last'});
  }
  function vehicles() {
    if(!vehiclesPromise) vehiclesPromise=window.pdlVehicleCompatibility.loadVehicles(config).catch(error => {vehiclesPromise=null;throw error;});
    return vehiclesPromise;
  }
  function vehicleMatches(query,entries) {
    const makerAliases={vw:'volkswagen',gm:'chevrolet'};
    const tokens=words(query).filter(token => !stop.has(token) && !/^\d{4}$/.test(token) && !['rack','racks','carro','carros','barras','teto','longarina','longarinas','thule','long','life'].includes(token)).map(token => makerAliases[token]||token);
    if(!tokens.length)return [];
    const cars=new Map();
    entries.forEach(entry => {
      const model=words(entry.model);
      const maker=words(entry.maker);
      const joined=compact(entry.model);
      const inputJoined=tokens.join('');
      const modelInput=tokens.filter(token => !maker.includes(token)).join('');
      const matches=tokens.every(token => prefix(token,`${entry.maker} ${entry.model}`) || (token.length>=3 && joined.startsWith(token))) || (inputJoined.length>=3 && joined.startsWith(inputJoined));
      const known=tokens.some(token => token.length>=3 && (model.some(word => word.startsWith(token)) || maker.includes(token) || joined.startsWith(token))) || (inputJoined.length>=3 && joined.startsWith(inputJoined));
      if(matches && known) {
        const key=`${compact(entry.maker)}|${compact(entry.model)}`;
        if(!cars.has(key)) cars.set(key,{key,maker:entry.maker,model:entry.model,entries:[],exact:joined===inputJoined || joined===modelInput?1:0});
        cars.get(key).entries.push(entry);
      }
    });
    const output=[...cars.values()].sort((a,b) => b.exact-a.exact || `${a.maker} ${a.model}`.localeCompare(`${b.maker} ${b.model}`,'pt-BR'));
    return output.some(car => car.exact)?output.filter(car => car.exact):output;
  }

  async function decorateTires(root,query,signal) {
    const requested=tireQuery(query);
    if(!requested || !root || signal?.aborted || !root.isConnected)return;
    const block=document.createElement('div');
    block.className='pdl-search-vehicle pdl-search-tires';
    block.dataset.pdlSearchVehicle='tires';
    block.innerHTML='<div class="pdl-search-vehicle__heading"><strong>'+escape(text.tireTitle)+'</strong><p>'+escape(text.tireDescription)+'</p></div><div class="pdl-search-vehicle__controls"><label><span class="pdl-search-vehicle__label">'+escape(text.tireRim)+'</span><select data-tire-rim aria-label="'+escape(text.tireRim)+'"></select></label><label><span class="pdl-search-vehicle__label">'+escape(text.tireWidth)+'</span><select data-tire-width aria-label="'+escape(text.tireWidth)+'"></select></label><button type="button" data-tire-go>'+escape(text.tireButton)+'</button></div><p class="pdl-search-tires__status" role="status" hidden></p>';
    const inner=root.querySelector('.predictive-search-results__inner') || root;
    inner.querySelector('[data-pdl-search-vehicle]')?.remove();inner.prepend(block);
    const rim=block.querySelector('[data-tire-rim]'),width=block.querySelector('[data-tire-width]'),button=block.querySelector('[data-tire-go]');
    const allLabel=()=>'<option value="">'+escape(text.tireAll)+'</option>';
    let catalog=config.tireMeasures || [];
    const loadWidths=(selected='')=>{
      const entry=catalog.find(item=>item.rim===rim.value);
      width.innerHTML=allLabel()+(entry?.widths || []).map(item=>'<option value="'+escape(tireWidth(item.width))+'">'+escape(item.label || item.width)+'</option>').join('');
      width.disabled=!rim.value;
      if(selected && [...width.options].some(option=>option.value===selected))width.value=selected;
    };
    const loadRims=(selected=requested.rim)=>{
      rim.innerHTML=allLabel()+catalog.map(item=>'<option value="'+escape(item.rim)+'">'+escape(text.tireRimLabel+' '+item.rim.replace('.',','))+'</option>').join('');
      if(selected && ![...rim.options].some(option=>option.value===selected))rim.add(new Option(text.tireRimLabel+' '+selected,selected));
      rim.value=selected;loadWidths(requested.width);
    };
    loadRims();
    rim.addEventListener('change',()=>loadWidths());
    button.addEventListener('click',()=>{
      const term='pneu'+(rim.value?' '+rim.value+(width.value?'x'+width.value:''):'');
      location.assign(searchUrl(term));
    });
    try {
      const result=await search('pneu');
      if(signal?.aborted || !block.isConnected)return;
      const measures=new Map();
      sourceProducts(result.products).forEach(product=>tireMeasures(product).forEach(measure=>{
        if(!measures.has(measure.rim))measures.set(measure.rim,new Map());
        const known=(config.tireMeasures || []).find(item=>item.rim===measure.rim)?.widths.find(item=>tireWidth(item.width)===measure.width);
        if(measure.width)measures.get(measure.rim).set(measure.width,known?.width || (measure.rim==='700'?measure.width.toUpperCase().replace(/c$/i,'')+'C':measure.width));
      }));
      if(measures.size) {
        const selectedRim=rim.value,selectedWidth=width.value;
        catalog=[...measures].sort((a,b)=>Number(a[0])-Number(b[0])).map(([rim,widths])=>({rim,widths:[...widths].sort((a,b)=>parseFloat(a[0])-parseFloat(b[0]) || a[0].localeCompare(b[0])).map(([key,label])=>({width:key,label}))}));
        loadRims(selectedRim);loadWidths(selectedWidth);
      }
    } catch {}
  }


  async function decorateRims(root,query,signal) {
    const requested=rimQuery(query);
    if(!requested || !root || signal?.aborted || !root.isConnected)return;
    const block=document.createElement('div');
    block.className='pdl-search-vehicle pdl-search-rims';block.dataset.pdlSearchVehicle='rims';
    block.innerHTML='<div class="pdl-search-vehicle__heading"><strong>'+escape(text.rimTitle)+'</strong><p>'+escape(text.rimDescription)+'</p></div><div class="pdl-search-vehicle__controls"><label><span class="pdl-search-vehicle__label">'+escape(text.tireRim)+'</span><select data-wheel-rim aria-label="'+escape(text.tireRim)+'"></select></label><label><span class="pdl-search-vehicle__label">'+escape(text.rimHoles)+'</span><select data-wheel-holes aria-label="'+escape(text.rimHoles)+'"></select></label><button type="button" data-wheel-go>'+escape(text.rimButton)+'</button></div>';
    const inner=root.querySelector('.predictive-search-results__inner') || root;
    inner.querySelector('[data-pdl-search-vehicle]')?.remove();inner.prepend(block);
    const rim=block.querySelector('[data-wheel-rim]'),holes=block.querySelector('[data-wheel-holes]');
    let catalog=config.rimMeasures || [];
    const all=()=>'<option value="">'+escape(text.tireAll)+'</option>';
    const loadHoles=(selected='')=>{
      const values=rim.value?(catalog.find(item=>item.rim===rim.value)?.holes || []):[...new Map(catalog.flatMap(item=>item.holes).map(item=>[item.holes,item])).values()].sort((a,b)=>Number(a.holes)-Number(b.holes));
      holes.innerHTML=all()+values.map(item=>'<option value="'+escape(item.holes)+'">'+escape(item.holes+' '+text.rimHolesSuffix)+'</option>').join('');
      holes.disabled=!rim.value && !requested.holes;
      if(selected && [...holes.options].some(option=>option.value===selected))holes.value=selected;
    };
    const loadRims=(selected=requested.rim,selectedHoles=requested.holes)=>{
      rim.innerHTML=all()+catalog.map(item=>'<option value="'+escape(item.rim)+'">'+escape(text.tireRimLabel+' '+item.rim.replace('.',','))+'</option>').join('');
      if(selected && ![...rim.options].some(option=>option.value===selected))rim.add(new Option(text.tireRimLabel+' '+selected,selected));
      rim.value=selected;loadHoles(selectedHoles);
    };
    loadRims();rim.addEventListener('change',()=>loadHoles());
    block.querySelector('[data-wheel-go]').addEventListener('click',()=>location.assign(searchUrl('aro'+(rim.value?' '+rim.value:'')+(holes.value?' '+holes.value+'f':''))));
    try {
      const result=await search('aro');
      if(signal?.aborted || !block.isConnected)return;
      const sizes=new Map();
      sourceProducts(result.products).forEach(product=>rimMeasures(product).forEach(measure=>{
        if(!sizes.has(measure.rim))sizes.set(measure.rim,new Set());
        if(measure.holes)sizes.get(measure.rim).add(measure.holes);
      }));
      if(sizes.size) {
        const selectedRim=rim.value,selectedHoles=holes.value;
        catalog=[...sizes].sort((a,b)=>Number(a[0])-Number(b[0])).map(([rim,holes])=>({rim,holes:[...holes].sort((a,b)=>Number(a)-Number(b)).map(holes=>({holes}))}));
        loadRims(selectedRim,selectedHoles);
      }
    } catch {}
  }


  async function decorateTubes(root,query,signal) {
    const requested=tubeQuery(query);
    if(!requested || !root || signal?.aborted || !root.isConnected)return;
    const block=document.createElement('div');
    block.className='pdl-search-vehicle pdl-search-tubes';block.dataset.pdlSearchVehicle='tubes';
    block.innerHTML='<div class="pdl-search-vehicle__heading"><strong>Encontre sua câmara de ar</strong><p>Escolha o aro e a medida que aparece no seu pneu.</p></div><form class="pdl-search-vehicle__controls"><label><span class="pdl-search-vehicle__label">Aro</span><select data-tube-rim aria-label="Aro da câmara"></select></label><label><span class="pdl-search-vehicle__label">Medida da câmara</span><select data-tube-width aria-label="Medida da câmara"></select></label><button type="submit">Buscar câmaras</button></form><p data-tube-status role="status" hidden></p>';
    const inner=root.querySelector('.predictive-search-results__inner') || root;
    inner.querySelector('[data-pdl-search-vehicle]')?.remove();inner.prepend(block);
    const rim=block.querySelector('[data-tube-rim]'),width=block.querySelector('[data-tube-width]'),status=block.querySelector('[data-tube-status]');
    const all='<option value="">Todas</option>';
    let catalog=config.tubeMeasures || [];
    function loadWidths(selected='') {
      const values=catalog.find(item=>item.rim===rim.value)?.widths || [];
      width.innerHTML=all+values.filter(Boolean).map(item=>'<option value="'+escape(item)+'">'+escape((rim.value+' × '+item).replace(/\./g,','))+'</option>').join('');
      width.disabled=!rim.value || !values.filter(Boolean).length;
      if(selected && [...width.options].some(item=>item.value===selected))width.value=selected;
    }
    function loadRims(selected='',selectedWidth='') {
      rim.innerHTML=all+catalog.map(item=>'<option value="'+escape(item.rim)+'">'+escape(item.rim==='700'?'700C':item.rim==='200'?'200 mm':'Aro '+item.rim.replace('.',','))+'</option>').join('');
      if([...rim.options].some(item=>item.value===selected))rim.value=selected;
      loadWidths(selectedWidth);
    }
    loadRims(requested.rim,requested.width);
    rim.addEventListener('change',()=>loadWidths());
    block.querySelector('form').addEventListener('submit',event=>{
      event.preventDefault();
      location.assign(searchUrl('camara'+(rim.value?' '+rim.value+(width.value?'x'+width.value:''):'')));
    });
    try {
      const products=await pages(localizedPath('/collections/camaras'),{view:'pdl-search-data'},'products');
      if(signal?.aborted || !block.isConnected)return;
      const sizes=new Map();
      products.filter(product=>product.available&&isTube(product)).forEach(product=>tubeMeasures(product).forEach(measure=>{
        if(!sizes.has(measure.rim))sizes.set(measure.rim,new Set());
        sizes.get(measure.rim).add(measure.width);
      }));
      catalog=[...sizes].sort((a,b)=>parseFloat(a[0])-parseFloat(b[0])).map(([rim,widths])=>({rim,widths:[...widths].sort((a,b)=>parseFloat(a)-parseFloat(b)||a.localeCompare(b,'pt-BR'))}));
      loadRims(rim.value || requested.rim,width.value || requested.width);
    } catch {
      status.hidden=false;status.textContent='Não foi possível atualizar as medidas. Você pode tentar novamente pela pesquisa.';
    }
  }
  function initializeTubeCollection() {
    document.querySelectorAll('[data-pdl-tube-finder]').forEach(root=>{
      if(root.dataset.ready==='true' && root.querySelector('[data-tube-rim]'))return;root.dataset.ready='true';
      void decorateTubes(root,'camara');
    });
  }

  async function decorateVehicles(root,query,signal) {
    if(tubeQuery(query))return decorateTubes(root,query,signal);
    if(rimQuery(query))return decorateRims(root,query,signal);
    if(tireQuery(query))return decorateTires(root,query,signal);
    try {
      const data=await vehicles();
      if(signal?.aborted || !root.isConnected)return;
      const cars=vehicleMatches(query,data.entries);
      if(!cars.length)return;
      const block=document.createElement('div');
      block.className='pdl-search-vehicle';block.dataset.pdlSearchVehicle='true';
      const carControl=cars.length===1?`<div class="pdl-search-vehicle__car"><span class="pdl-search-vehicle__label">${escape(text.vehicleModel)}</span><strong class="pdl-search-vehicle__model">${escape(`${cars[0].maker} ${cars[0].model}`)}</strong><input type="hidden" data-car-model value="0"></div>`:`<label class="pdl-search-vehicle__car"><span class="pdl-search-vehicle__label">${escape(text.vehicleModel)}</span><select data-car-model><option value="">${escape(text.chooseModel)}</option>${cars.map((car,index) => `<option value="${index}">${escape(`${car.maker} ${car.model}`)}</option>`).join('')}</select></label>`;
      block.innerHTML=`<div class="pdl-search-vehicle__heading"><strong>${escape(text.vehicleTitle)}</strong><p>${escape(text.vehicleDescription)}</p></div><div class="pdl-search-vehicle__controls">${carControl}<label><span class="pdl-search-vehicle__label">${escape(text.year)}</span><select data-car-year disabled><option value="">${escape(text.chooseYear)}</option></select></label><label data-car-roof-label hidden><span class="pdl-search-vehicle__label">${escape(text.roof)}</span><select data-car-roof disabled></select></label><button type="button" data-car-go disabled>${escape(text.vehicleButton)}</button></div>`;
      const inner=root.querySelector('.predictive-search-results__inner') || root;
      inner.querySelector('[data-pdl-search-vehicle]')?.remove();inner.prepend(block);
      const model=block.querySelector('[data-car-model]');const year=block.querySelector('[data-car-year]');const roof=block.querySelector('[data-car-roof]');const button=block.querySelector('[data-car-go]');
      const requestedYear=query.match(/\b(?:19|20)\d{2}\b/)?.[0];
      function changeYear() {
        const car=cars[Number(model.value)];
        const choices=model.value!=='' && year.value?new Set(car.entries.filter(entry => Number(year.value)>=entry.startYear && Number(year.value)<=entry.endYear).map(window.pdlVehicleCompatibility.roofTypeForEntry)):new Set();
        const labels={none:text.roofNone,integrated:text.roofIntegrated,raised:text.roofRaised};
        roof.innerHTML=(choices.size>1?`<option value="">${escape(text.chooseRoof)}</option>`:'')+[...choices].map(value => `<option value="${value}">${escape(labels[value]||value)}</option>`).join('');
        roof.disabled=!choices.size;block.querySelector('[data-car-roof-label]').hidden=choices.size<=1;button.disabled=!(year.value && roof.value);
      }
      function changeModel() {
        const car=model.value!==''?cars[Number(model.value)]:null;
        const years=car?window.pdlVehicleCompatibility.yearsForEntries(car.entries,config.maxYear):[];
        year.innerHTML=`<option value="">${escape(text.chooseYear)}</option>`+years.map(value => `<option value="${value}">${value}</option>`).join('');
        year.disabled=!years.length;if(requestedYear && years.includes(Number(requestedYear)))year.value=requestedYear;changeYear();
      }
      model.addEventListener('change',changeModel);year.addEventListener('change',changeYear);roof.addEventListener('change',() => button.disabled=!(year.value && roof.value));
      button.addEventListener('click',() => {if(button.disabled)return;const car=cars[Number(model.value)];location.assign(urlFor(config.rackUrl || localizedPath('/pages/racks-e-transbikes'),{maker:car.maker,model:car.model,year:year.value,roof:roof.value,search:'1'}));});
      changeModel();
    } catch {}
  }
  async function cardMarkup(products,sectionId) {
    const sources=sourceProducts(products);
    const batches=Array.from({length:Math.ceil(sources.length/40)},(_,index)=>sources.slice(index*40,index*40+40));
    const documents=await Promise.all(batches.map(batch=>{
      const url=urlFor(config.searchUrl || localizedPath('/search'),{q:batch.map(product => String(product.id)).sort().map(id => `id:${id}`).join(' OR '),type:'product',section_id:sectionId,'options[unavailable_products]':'hide','options[prefix]':'none'});
      return cached(`cards:${url}`,async () => {
        const response=await fetch(url,{headers:{Accept:'text/html'}});
        if(!response.ok)throw new Error(text.error);
        return response.text();
      });
    }));
    return documents.join('\n');
  }
  async function quickPreview(query) {
    if(tubeQuery(query) || tireQuery(query) || rimQuery(query))return search(query);
    const key=normalize(query);
    if(completed.has(key))return completed.get(key);
    const units=unitsFor(query);
    if(!units.length)return {products:[],collections:[],units};
    const url=urlFor(config.searchUrl || localizedPath('/search'),{q:nativeQuery(query,units),type:'product','options[unavailable_products]':'hide','options[prefix]':'last',view:'pdl-search-preview'});
    const [data,catalog]=await Promise.all([cached(`preview:${url}`,()=>json(url)),collections()]);
    const products=logicalProducts(data.products.map(product=>match(product,query,units)).filter(Boolean));
    if(!products.length)return search(query);
    const matchedSources=sourceProducts(products);
    const suggested=catalog.map(collection=>({...collection,score:collectionScore(collection,units)})).filter(collection=>collection.score>0 && matchedSources.some(product=>product.collections.some(item=>item.handle===collection.handle))).sort((a,b)=>b.score-a.score || a.title.localeCompare(b.title,'pt-BR')).slice(0,4);
    return {products,collections:suggested,units};
  }
  async function preview(query,signal) {
    const start=performance.now();
    const result=await quickPreview(query);
    if(signal?.aborted)throw new DOMException('Aborted','AbortError');
    void search(query).catch(()=>{});
    const sectionId=document.querySelector('[data-pdl-smart-results]')?.getAttribute('section-id');
    if(sectionId && result.products.length)void cardMarkup(result.products.slice(0,24),sectionId).catch(()=>{});
    return markup(query,result).replace('data-search-results',`data-pdl-preview-ms="${Math.round(performance.now()-start)}" data-search-results`);
  }
  let nativeFacetsUpdate;
  function updateFacets(component,parameters) {
    if(!component.closest('[data-pdl-smart-mount]') || !nativeFacetsUpdate)return false;
    nativeFacetsUpdate(parameters);return true;
  }
  function filterParameters(parameters) {
    const filters=new URLSearchParams();
    for(const [name,value] of parameters) {
      if(!name.startsWith('filter.') || value==='')continue;
      const normalized=name.startsWith('filter.v.price.') && value.includes(',')?value.replace(/\./g,'').replace(',','.'):value;
      filters.append(name,normalized);
    }
    filters.sort();return filters;
  }
  async function nativeFacetDocuments(products,sectionId,filters) {
    const batches=[];
    for(let index=0;index<products.length;index+=200)batches.push(products.slice(index,index+200));
    if(!batches.length)return [];
    return Promise.all(batches.map(batch => {
      const url=urlFor(config.searchUrl || localizedPath('/search'),{q:'id:0 OR '+batch.map(product => String(product.id)).sort().map(id => `id:${id}`).join(' OR '),type:'product',section_id:sectionId,'options[unavailable_products]':'hide','options[prefix]':'none'});
      for(const [name,value] of filters)url.searchParams.append(name,value);
      return cached(`facets:${url}`,async () => {
        const response=await fetch(url,{headers:{Accept:'text/html'}});
        if(!response.ok)throw new Error(text.error);
        return response.text();
      });
    }));
  }
  function mergeNativeFacets(documents) {
    const parts=documents.map(doc => [...doc.querySelectorAll('.collection-wrapper > .facets-controls-wrapper,.collection-wrapper > .facets-block-wrapper,.collection-wrapper > .facets-toggle')]);
    const base=parts.reduce((best,part) => part.reduce((n,node)=>n+node.querySelectorAll('input[type="checkbox"]').length,0)>best.reduce((n,node)=>n+node.querySelectorAll('input[type="checkbox"]').length,0)?part:best,parts[0] || []);
    const groupKey=group => group.dataset.filterParamName || group.querySelector('input[name]')?.name || '';
    for(const part of parts) {
      if(part===base)continue;
      part.forEach((node,index) => {
        const target=base[index];if(!target)return;
        const targetGroups=[...target.querySelectorAll('.facets__filters-wrapper > accordion-custom')];
        for(const group of node.querySelectorAll('.facets__filters-wrapper > accordion-custom')) {
          const current=targetGroups.find(item => groupKey(item)===groupKey(group));
          if(!current) {target.querySelector('.facets__filters-wrapper')?.append(group.cloneNode(true));continue;}
          const incomingPrice=group.querySelector('price-facet-component');
          if(incomingPrice) {
            const minor=value=>Number(String(value || '').replace(/\./g,'').replace(',','.'));
            if(minor(incomingPrice.querySelector('[ref="maxInput"]')?.dataset.max)>minor(current.querySelector('[ref="maxInput"]')?.dataset.max))current.replaceWith(group.cloneNode(true));
            continue;
          }
          const list=current.querySelector('.facets__inputs-list');if(!list)continue;
          for(const item of group.querySelectorAll('.facets__inputs-list > li')) {
            const input=item.querySelector('input[name]');if(!input)continue;
            const existing=[...list.querySelectorAll('input[name]')].find(candidate=>candidate.name===input.name && candidate.value===input.value);
            if(!existing)list.append(item.cloneNode(true));
            else if(existing.disabled && !input.disabled)existing.closest('li').replaceWith(item.cloneNode(true));
          }
          list.querySelectorAll('li').forEach(item=>{item.classList.remove('hidden','mobile:hidden');item.removeAttribute('ref');});
        }
      });
    }
    let inputIndex=0;
    for(const node of base) {
      node.querySelectorAll('script').forEach(script=>script.remove());
      for(const input of node.querySelectorAll('.facets__inputs-list input[id]')) {
        const old=input.id;input.id=`${old}-pdl-${inputIndex++}`;
        input.closest('li')?.querySelectorAll('label').forEach(label=>{if(label.htmlFor===old)label.htmlFor=input.id;});
      }
    }
    return base;
  }
  async function resultsPage() {
    const root=document.querySelector('[data-pdl-smart-results]');
    const stateUrl=new URL(location.href);
    const query=stateUrl.searchParams.get('q') || '';
    if(!root || !query.trim())return;
    const host=root.querySelector('[data-pdl-smart-mount]');if(!host)return;
    const startTime=performance.now();
    root.setAttribute('infinite-scroll','true');
    const gridTemplate=host.querySelector('[data-smart-grid]').cloneNode(false);
    const sectionId=root.getAttribute('section-id');
    let page=Math.max(1,Number(stateUrl.searchParams.get('page') || stateUrl.searchParams.get('pdl_page'))||1);
    let sort=stateUrl.searchParams.get('pdl_sort') || stateUrl.searchParams.get('sort_by') || 'relevance';
    let filters=filterParameters(stateUrl.searchParams);
    if(!filters.has('filter.v.availability'))filters.set('filter.v.availability','1');
    let renderVersion=0;
    let facetsVersion=0;
    let filteredProducts=[];
    const setCounts=count => {
      host.querySelectorAll('.products-count-wrapper [role="status"]').forEach(node=>node.textContent=`${count} ${text.products}`);
      const see=host.querySelector('.facets__see-results');if(see)see.textContent=see.textContent.replace(/\d[\d.,]*/,String(count));
    };
    const syncView=() => {
      const grid=host.querySelector('[data-smart-grid]');
      const view=grid?.getAttribute('product-grid-view') || 'default';
      host.querySelectorAll('input[name="grid"],input[name="grid-mobile"]').forEach(input=>input.checked=input.value===view);
    };
    const syncSort=()=> {
      host.querySelectorAll('input[name="sort_by"]').forEach(input=>{
        input.checked=input.value===sort;
        const option=input.closest('[role="option"]');
        if(option){option.setAttribute('aria-selected',String(input.checked));option.tabIndex=input.checked?0:-1;}
      });
      host.querySelectorAll('select[name="sort_by"]').forEach(select=>select.value=sort);
      host.querySelectorAll('sorting-filter-component').forEach(component=> {
        const selected=component.querySelector('input[name="sort_by"]:checked');
        const status=component.querySelector('.facets__status');
        if(selected && status)status.textContent=selected.dataset.optionName || '';
      });
    };
    const writeUrl=push => {
      const url=new URL(location.href);
      for(const key of [...url.searchParams.keys()])if(key.startsWith('filter.'))url.searchParams.delete(key);
      for(const [name,value] of filters)url.searchParams.append(name,value);
      for(const [name,value] of Object.entries({pdl_page:page>1?page:'',pdl_sort:sort==='relevance'?'':sort})) {if(value!=='')url.searchParams.set(name,value);else url.searchParams.delete(name);}
      url.searchParams.delete('sort_by');url.searchParams.delete('page');
      history[push?'pushState':'replaceState']({},'',url);
    };
    try {
      const morphPromise=import('@theme/morph');
      const completePromise=search(query);
      completePromise.catch(()=>{});
      const initialFilters=filters.toString()==='filter.v.availability=1';
      const first=initialFilters?await Promise.race([
        completePromise.then(result=>({result,complete:true})),
        quickPreview(query).then(result=>({result,complete:false}))
      ]):{result:await completePromise,complete:true};
      let result=first.result;
      host.dataset.pdlSearchMatchMs=String(Math.round(performance.now()-startTime));
      filteredProducts=result.products;
      host.querySelector('[data-smart-collections]').innerHTML=collectionMarkup(result);
      void decorateVehicles(host.querySelector('[data-smart-vehicles]'),query);
      async function refreshFacets() {
        const version=++facetsVersion;
        const html=await nativeFacetDocuments(sourceProducts(result.products),sectionId,filters);
        if(version!==facetsVersion)return;
        if(!html.length){host.dataset.smartFacetsReady='true';return;}
        const documents=html.map(markup=>new DOMParser().parseFromString(markup,'text/html'));
        const ids=new Set(documents.flatMap(doc=>JSON.parse(doc.querySelector('[data-pdl-matched-ids]')?.content.textContent || '[]')).map(String));
        filteredProducts=logicalProducts(sourceProducts(result.products).filter(product=>ids.has(String(product.id))));
        const parts=mergeNativeFacets(documents);
        const {morph,MORPH_OPTIONS}=await morphPromise;
        if(version!==facetsVersion)return;
        for(const part of parts) {
          const selector=part.matches('.facets-toggle')?'.facets-toggle':part.matches('dialog-component')?'dialog-component.facets-block-wrapper':part.matches('.facets-controls-wrapper')?'.facets-controls-wrapper':'.facets-block-wrapper:not(dialog-component)';
          const original=host.querySelector(`:scope > ${selector}`);
          if(original) {
            const oldDialog=original.querySelector('dialog');
            const newDialog=part.querySelector('dialog');
            if(oldDialog?.open && newDialog)newDialog.setAttribute('open','');
            const groupState=new Map([...original.querySelectorAll('details')].map(node=>[node.id,node.open]));
            part.querySelectorAll('details').forEach(node=>{if(groupState.has(node.id))node.open=groupState.get(node.id);});
            morph(original,part,{...MORPH_OPTIONS,childrenOnly:true});
            original.updatedCallback?.();
          } else host.insertBefore(part,host.querySelector('#ResultsList'));
        }
        for(const node of host.querySelectorAll('[data-url]')) {
          const url=new URL(node.dataset.url,location.origin);url.searchParams.set('q',query);url.searchParams.set('type','product');url.searchParams.set('options[unavailable_products]','hide');
          node.dataset.url=String(url);
        }
        syncSort();
        host.dataset.smartFacetsReady='true';setCounts(filteredProducts.length);syncView();
        host.dataset.pdlSearchFacetsMs=String(Math.round(performance.now()-startTime));
      }
      const sortedProducts=()=> {
        const products=[...filteredProducts];
        if(sort==='price-ascending')products.sort((a,b)=>a.price-b.price || b.score-a.score);
        else if(sort==='price-descending')products.sort((a,b)=>b.price-a.price || b.score-a.score);
        else if(sort==='title-ascending')products.sort((a,b)=>a.title.localeCompare(b.title,'pt-BR'));
        else if(sort==='title-descending')products.sort((a,b)=>b.title.localeCompare(a.title,'pt-BR'));
        return products;
      };
      async function buildGrid(products,pageNumber,view='default') {
        const current=products.slice((pageNumber-1)*24,pageNumber*24);
        const grid=gridTemplate.cloneNode(false);
        grid.setAttribute('product-grid-view',view);
        grid.setAttribute('data-last-page',String(Math.ceil(products.length/24)));
        grid.removeAttribute('aria-busy');
        if(!current.length)grid.innerHTML=`<li class="pdl-smart-status">${escape(text.noResults)}</li>`;
        else {
          const doc=new DOMParser().parseFromString(await cardMarkup(current,sectionId),'text/html');
          const cards=prepareLogicalCards([...doc.querySelectorAll('.product-grid__item')],current,pageNumber);
          cards.forEach(card=>grid.append(card));
          if(!grid.children.length)throw new Error(text.error);
        }
        return grid;
      }
      async function render(updateUrl=false) {
        const version=++renderVersion;
        const products=sortedProducts();
        page=Math.min(page,Math.max(1,Math.ceil(products.length/24)));
        setCounts(products.length);syncSort();
        if(updateUrl)writeUrl(false);
        const oldGrid=host.querySelector('[data-smart-grid]');oldGrid.setAttribute('aria-busy','true');
        const grid=await buildGrid(products,page,oldGrid.getAttribute('product-grid-view') || 'default');
        if(version!==renderVersion)return;
        oldGrid.replaceWith(grid);root.updatedCallback?.();host.querySelector('[data-smart-loading]').hidden=true;
        await customElements.whenDefined('results-list');
        if(version!==renderVersion)return;
        root.setSearchPageLoader(async pageNumber=> {
          const nextGrid=await buildGrid(products,pageNumber);
          if(version!==renderVersion)return '';
          return nextGrid.outerHTML;
        });
        if(!host.dataset.pdlSearchCardsMs)host.dataset.pdlSearchCardsMs=String(Math.round(performance.now()-startTime));
      }
      nativeFacetsUpdate=parameters => {
        const nextFilters=filterParameters(parameters);
        const nextSort=parameters.get('pdl_sort') || parameters.get('sort_by') || 'relevance';
        const changed=nextFilters.toString()!==filters.toString();
        filters=nextFilters;sort=nextSort==='most-relevant'?'relevance':nextSort;page=1;writeUrl(true);
        const update=async()=>{
          if(changed){host.dataset.smartFacetsReady='false';host.querySelector('[data-smart-grid]').setAttribute('aria-busy','true');await refreshFacets();}
          await render(true);
        };
        void update().catch(showError);
      };
      window.addEventListener('popstate',()=>{
        const url=new URL(location.href);filters=filterParameters(url.searchParams);sort=url.searchParams.get('pdl_sort') || 'relevance';page=Math.max(1,Number(url.searchParams.get('page') || url.searchParams.get('pdl_page'))||1);
        void refreshFacets().then(()=>render()).catch(showError);
      });
      function showError() {
        const status=host.querySelector('[data-smart-loading]');status.hidden=false;
        status.innerHTML=`<span role="alert">${escape(text.error)}</span> <button type="button" data-smart-retry>${escape(text.retry)}</button>`;
        status.querySelector('[data-smart-retry]').addEventListener('click',()=>refreshFacets().then(()=>render()).catch(showError));
      }
      if(!first.complete) {
        await render();
        host.querySelectorAll('.products-count-wrapper [role="status"]').forEach(node=>node.textContent=text.loading);
        result=await completePromise;
        filteredProducts=result.products;
        host.querySelector('[data-smart-collections]').innerHTML=collectionMarkup(result);
      }
      if(initialFilters)await Promise.all([render(),refreshFacets()]);else {await refreshFacets();await render();}
      host.dataset.smartReady='true';host.dataset.pdlSearchLoadMs=String(Math.round(performance.now()-startTime));
    } catch {
      const status=host.querySelector('[data-smart-loading]');status.hidden=false;
      status.innerHTML=`<span role="alert">${escape(text.error)}</span> <button type="button" data-smart-retry>${escape(text.retry)}</button>`;
      status.querySelector('[data-smart-retry]').addEventListener('click',()=>location.reload());
    }
  }
  document.addEventListener('focusin',event => {if(event.target.matches?.('input[name="q"]'))void collections().catch(() => {});},true);
  window.PDLSmartSearch={search,preview,decorateVehicles,searchUrl,match,unitsFor,vehicleMatches,normalize,updateFacets,quickPreview,tireQuery,tireMeasure,tireMeasures,rimQuery,rimMeasures,tubeQuery,tubeMeasure,tubeMeasures,tubeWidthMatches};
  document.addEventListener('submit',event => {
    const form=event.target;
    if(!(form instanceof HTMLFormElement) || !new URL(form.action,location.origin).pathname.endsWith('/search'))return;
    const input=form.querySelector('input[name="q"]');if(!input)return;
    event.preventDefault();event.stopImmediatePropagation();location.assign(searchUrl(input.value));
  },true);
  const boot=()=>{initializeTubeCollection();new MutationObserver(()=>initializeTubeCollection()).observe(document.body,{childList:true,subtree:true});void resultsPage();};
  document.addEventListener('shopify:section:load',initializeTubeCollection);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();


